export const isRumEnabledForCompany = (
  datadogEnvironment: string,
  allowedCompanyIds: string[],
  companyId: string | undefined
): boolean => {
  if (datadogEnvironment.startsWith('demo')) {
    return true
  }

  if (!companyId) {
    return false
  }

  return allowedCompanyIds.includes(companyId)
}
